import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { useSelector } from "react-redux";
import { MONTH_LABELS, chartScales, chartTooltipStyle, YearSelect } from "./chartTheme";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const PaymentChart = ({ selectedYear, onYearChange, years }) => {
  const orders = useSelector((state) => state.AdminOrders.OrderData);
  const [internalYear, setInternalYear] = useState(selectedYear ?? new Date().getFullYear());
  const year = selectedYear ?? internalYear;
  const setYear = onYearChange ?? setInternalYear;
  const [orderPayments, setOrderPayments] = useState(Array(12).fill(0));

  useEffect(() => {
    if (selectedYear != null) {
      setInternalYear(selectedYear);
    }
  }, [selectedYear]);

  useEffect(() => {
    const filterOrders = orders?.filter((order) => {
      const orderYear = new Date(order?.createdAt)?.getFullYear();
      return orderYear === year;
    });

    const counts = Array(12).fill(0);
    filterOrders?.forEach((order) => {
      const month = new Date(order?.createdAt)?.getMonth();
      counts[month] += order?.totalAmount || 0;
    });
    setOrderPayments(counts);
  }, [year, orders]);

  const maxPayment = Math.max(...orderPayments, 1);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { ...chartTooltipStyle },
    },
    scales: {
      ...chartScales,
      y: {
        ...chartScales.y,
        suggestedMax: maxPayment,
      },
    },
  };

  const data = {
    labels: MONTH_LABELS,
    datasets: [
      {
        label: "Total Amount",
        data: orderPayments,
        borderColor: "#E52324",
        backgroundColor: "rgba(229, 35, 36, 0.08)",
        pointBackgroundColor: "#E52324",
        pointRadius: 3,
        pointHoverRadius: 4,
        borderWidth: 2,
        fill: true,
        tension: 0.35,
      },
    ],
  };

  return (
    <div className="bg-[#0F172A] border border-[#1a2744] rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white text-[15px]" style={{ fontWeight: 700 }}>
          Payment Chart
        </h3>
        <YearSelect years={years} value={year} onChange={setYear} />
      </div>
      <div className="text-[10px] text-white/25 mb-2">Orders Chart Month Wise</div>
      <div className="flex items-center gap-2 mb-3">
        <span className="w-3 h-3 rounded bg-[#E52324]" />
        <span className="text-[10px] text-white/35">Total Amount</span>
      </div>
      <div className="h-[200px]">
        <Line options={options} data={data} />
      </div>
    </div>
  );
};

export default PaymentChart;
